var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.4 80c16.57 0 30-7.39 30-16.5S56.97 47 40.4 47s-30 7.39-30 16.5S23.83 80 40.4 80Z",
    fill: "#0061AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4 61.91V29.32a3.3 3.3 0 0 1 2.08-3.04L70.3 15c.05-.01.1.02.1.07V50.26L41.95 62.9a1.1 1.1 0 0 1-1.55-.99Z",
    fill: "white",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38.02 26.42-27.58-11.7c-.05-.01-.05-.08 0-.1l29.69-12.5c.4-.16.82-.16 1.2 0l28.86 12.3c.28.11.28.53 0 .65L43.46 26.42a6.68 6.68 0 0 1-5.44 0Z",
    fill: "white",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.97 13.03c-.28-.11-.57.1-.57.41l.54 35.7c0 .92.54 1.76 1.36 2.1L40.35 63c.03.01.06-.02.05-.04l-.08-35.56c0-.77-.43-1.44-1.1-1.75L10.97 13.03Z",
    fill: "white",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 21.78V37l8-4.05V18l-8 3.78Z",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m54 22-7.6-4.32L55.73 13l7.67 4.36L54 22Z",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 20 55.4 7.64l-13.66-5.4a2.83 2.83 0 0 0-2.22-.03l-27.94 11.7c-.24.12-.24.45 0 .54L25.6 20Z",
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/parcel.68a984ce2a026f8e32262e81774c7e9b.svg";